<template>
  <div id="register">
    <h1>{{ $t('newRegister') }}</h1>
    <!-- <ul class="register-type list-unstyled">
      <li @click="isEmailRegister=true">
        <a href="javascript:void(0)" :class="{'active': isEmailRegister}" >{{ $t('emailRegister') }}</a>
      </li>
      <li @click="isEmailRegister=false">
        <a href="javascript:void(0)" :class="{'active': !isEmailRegister}" >{{ $t('phoneRegister') }}</a>
      </li>
    </ul> -->

    <email-register class="email-phone-register"></email-register>
    <!-- <phone-register class="email-phone-register" v-show="!isEmailRegister"></phone-register> -->

    <third-part-login class="oauth-login"></third-part-login>

    <!-- <p id="have-account">{{ $t('haveAccount') }}
      <router-link to="/login">{{ $t('signIn') }}</router-link>
    </p> -->
  </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/mixins/button";
  @import "../../../assets/scss/formstyle";

  #register {
    max-width: 4rem;
    width: 100%;
    margin: 0 auto;
    h1 {
      font-size: 24px;
      line-height: 24px;
      font-weight: 600;
      text-align: center;
    }
  }

  .register-type {
    clear: both;
    padding: 0;
    display: block;
    border-bottom: 1px solid #EFEFEF;
    height: .36rem;
    text-align: center;
    li {
      display: inline-block;
      a {
        color: #999;
        display: inline-block;
        height: .36rem;
        padding: 0 .08rem;
      }
      .active {
        color: #333333;
        border-bottom: 2px solid #EC55FF;
      }
      &:first-child {
        margin-right: .4rem;
      }
      &:last-child {
        margin-left: .4rem;
      }
    }
  }

  .email-phone-register {
    margin-top: .4rem;
  }

  .oauth-login {
    max-width: 4rem;
  }

  #have-account {
    @include contentMaxWidth();
    color: #999;
    letter-spacing: 0;
    line-height: .16rem;
    text-align: center;
    a {
      color: #416CF8;
    }
  }

  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
  }
</style>


<script>
  // import PhoneRegister from '../../../components/registerform/PhoneRegister.vue'
  import EmailRegister from '../../../components/registerform/EmailRegister.vue'
  import ThirdPartLogin from '../../../components/loginform/oauthLogin/ThirdPartLogin.vue'
  import locales from './lang.js'

  export default {
    name: 'register-form-view',
    components: {
      EmailRegister,
      // PhoneRegister,
      ThirdPartLogin
    },
    data: function () {
      return {
        isEmailRegister: true
      }
    },
    locales,
    created: function () {
      this.$store.commit('setTrackEventLabel', 'Standalone page register form')
    },
    mounted() {
      this.$store.commit('getLoginPage', true)
    },
    destroyed() {
      this.$store.commit('getLoginPage', false)
    }
  }
</script>



// WEBPACK FOOTER //
// Register.vue?39eab36c